import ExceptionErrorLogsPopup from "./ExceptionErrorLogsPopup";

const ExceptionErrorLogsPopupContainer = (props: any) =>{

    const exceptionErrorLogDetails = props.exceptionErrorLogDetails
    let dateValue = new Date(exceptionErrorLogDetails?.created)
    return(
        <ExceptionErrorLogsPopup
        exceptionErrorLogDetails={exceptionErrorLogDetails} 
        dateValue={dateValue}       
        />
    )
}

export default ExceptionErrorLogsPopupContainer;